import {useMutation} from 'react-query';
import postStoreOrderApproval from './postStoreOrderApproval';

export interface IPostStoreOrderApprovalPayload {
  action: 'accept' | 'reject';
  supplier_provide_at?: string;
  orderGuid?: string;
}

const usePostStoreOrderApproval = (handleAfterSuccess?: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostStoreOrderApprovalPayload) => {
      return postStoreOrderApproval(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostStoreOrderApproval;
